import { useState } from "react";
import { useDeleteQuery, useGetQuery } from "../hooks";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import EditButton from "./EditButton";
import PerformedResponsibilityAdd from "./PerformedResponsibilityAdd";
import PerformedResponsibilityEdit from "./PerformedResponsibilityEdit";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";
import DeleteButton from "./DeleteButton";
import { useDataContext } from "../contexts";
import Heading from "./Heading";

export default function PerformedResponsibilityCRUD({ submission }) {
  const { getMemberUserById } = useDataContext();

  const performedResponsibilitiesQuery = useGetQuery(
    "performed-responsibilities",
    {
      queryParams: { submission: submission.id },
    }
  );
  const deletePerformedResponsibility = useDeleteQuery(
    "performed-responsibilities"
  );

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState(null);
  const [deleteModalId, setDeleteModalId] = useState(null);

  if (performedResponsibilitiesQuery.isLoading) {
    return null;
  }

  const submissionUser = getMemberUserById(submission.user);

  const percentage =
    submission.responsibilitiesRequired > 0
      ? (submission.responsibilitiesPerformed /
          submission.responsibilitiesRequired) *
        100
      : 0;

  return (
    <Panel
      left="Performed responsibilities"
      right={`${percentage.toFixed(0)}% (£${submission.responsibilitiesTotal})`}
    >
      <Grid
        data={performedResponsibilitiesQuery.data}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto]"
        renderTestId={(performedResponsibility) =>
          `Performed responsibility ${performedResponsibility.name} ${performedResponsibility.datePerformed}`
        }
        columns={[
          { header: "Name", key: "name" },
          { header: "Date", key: "datePerformed" },
          {
            header: "Actions",
            render: (responsibility) => (
              <Actions>
                <EditButton
                  key="edit"
                  onClick={() => setEditModalId(responsibility.id)}
                />
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(responsibility.id)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Performed Responsibility"
      >
        <PerformedResponsibilityAdd
          user={submissionUser}
          callback={() => {
            setAddModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        isOpen={editModalId !== null}
        onClose={() => setEditModalId(null)}
        heading="Edit Performed Responsibility"
      >
        {editModalId && (
          <PerformedResponsibilityEdit
            id={editModalId}
            callback={() => {
              setEditModalId(null);
            }}
          />
        )}
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Performed Responsibility"
        message="Are you sure you want to delete this performed responsibility?"
        confirmLabel="Delete"
        onConfirm={() => {
          deletePerformedResponsibility.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
